import { IPersonMatch, universalPeopleSearch } from 'es/app/business-logic/services/universal-search/PeopleSearch';
import { IUniversalSearchCriteria } from 'es/app/business-logic/services/universal-search/UniversalSearch';
import {
    UniversalSearchMatch,
    UniversalSearchResults,
} from 'es/app/components/layout/universal-search/UniversalSearchResults';
import SystemRouteMap from 'es/app/views/system/RouteMap';
import { useI18n } from 'es/core/hooks/useI18n';
import usePromiseTracker from 'es/core/hooks/usePromiseTracker';
import { useEffect, useState } from 'react';
import { usePromise } from 'react-use';

interface ISearchProvider {
    criteria: IUniversalSearchCriteria;
}

const PersonMatch = ({ person }: { person: IPersonMatch }) => {
    const heading =
        person.firstName && person.lastName ? `${person.firstName} ${person.lastName}` : person.emailAddress;

    const route = SystemRouteMap.people.edit(person.type, person.id).root;

    return (
        <UniversalSearchMatch match={person} heading={heading ?? ''} route={route}>
            {person.emailAddress}
        </UniversalSearchMatch>
    );
};

const PersonSearch = (props: ISearchProvider) => {
    const { l10n } = useI18n('app/components/layout', 'universalSearch');
    const { criteria } = props;

    const resolveIfMounted = usePromise();
    const { isBusy, trackPromise } = usePromiseTracker();

    const [searchResults, setSearchResults] = useState<IPersonMatch[]>([]);

    useEffect(() => {
        setSearchResults([]);

        if (!(criteria.id || criteria.text)) {
            return;
        }

        const { abandon } = trackPromise(async () => {
            const people = await resolveIfMounted(universalPeopleSearch(criteria));
            setSearchResults(people);
        });

        return abandon;
    }, [criteria, resolveIfMounted, trackPromise]);

    if (!(isBusy || (searchResults && searchResults.length))) return null;

    return (
        <UniversalSearchResults provider={l10n('person.providerName')}>
            {isBusy && l10n('activity.searching')}

            {searchResults.map(person => (
                <PersonMatch key={person.id} person={person} />
            ))}
        </UniversalSearchResults>
    );
};

export default PersonSearch;
